import { tokens } from "../../config/tokens.mjs";
const typography = {
  "link-default": tokens.color["blue.600"],
  "link-disabled": tokens.color["grey.500"],
  "link-focused": tokens.color["blue.600"],
  "link-hovered": tokens.color["blue.500"],
  "link-pressed": tokens.color["blue.500"],
  "text-disabled": tokens.color["grey.500"],
  "text-discreet": tokens.color["grey.600"],
  "text-error": tokens.color["red.600"],
  "text-primary": tokens.color["grey.800"],
  "text-secondary": tokens.color["grey.700"],
  "text-success": tokens.color["green.600"]
};
export { typography };
//# sourceMappingURL=typography.mjs.map
